export default function categoryTitleReducer(category: string): string {
  switch (category) {
    case 'date': {
      return 'Por fecha';
    }
    case 'plan': {
      return 'Por tipo de plan';
    }
    case 'origin': {
      return 'Origen de la cotización';
    }
    case 'status': {
      return 'Por estado';
    }
    case 'user': {
      return 'Por usuario';
    }
    default: {
      return '';
    }
  }
}
